import type { ButtonHTMLAttributes } from 'react'

import { cn } from '@/legacy-src/lib/utils'

export type ClientBookingMonthCalendarNavButtonProps = ButtonHTMLAttributes<HTMLButtonElement>

export const ClientBookingMonthCalendarNavButton = ({
  className,
  ...props
}: ClientBookingMonthCalendarNavButtonProps) => (
  <button
    {...props}
    className={cn(
      'inline-flex size-8 appearance-none items-center justify-center rounded-xl border-0 bg-transparent p-0 text-petrol-500 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 aria-disabled:cursor-not-allowed aria-disabled:opacity-35',
      className,
    )}
  />
)
